import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

export const Navigation = (props) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const company = props.data || {};

  return (
    <nav
      id="menu"
      className={`navbar navbar-default navbar-fixed-top${
        scrolled ? " navbar-scrolled" : ""
      }`}
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className={`navbar-toggle${open ? "" : " collapsed"}`}
            onClick={() => setOpen(!open)}
            aria-expanded={open}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <Link className="navbar-brand" to="/">
            <span className="brand-mark">{company.name || "International Rocks"}</span>
            <small className="brand-sub">{company.country || "Sultanate of Oman"}</small>
          </Link>
        </div>

        <div className={`navbar-collapse collapse${open ? " in" : ""}`}>
          <ul className="nav navbar-nav navbar-right">
            <li>
              <NavLink to="/" end>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about">About Us</NavLink>
            </li>
            <li>
              <NavLink to="/products">Products</NavLink>
            </li>
            <li>
              <NavLink to="/granite">Granite</NavLink>
            </li>
            <li>
              <Link to="/#materials">Marble</Link>
            </li>
            <li>
              <Link to="/#gallery">Gallery</Link>
            </li>
            <li>
              <NavLink to="/contact">Contact</NavLink>
            </li>
            <li className="nav-cta">
              <Link to="/contact" className="btn btn-custom btn-sm">
                Request a Quote
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
